import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "m-res-anthro" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AnthropometryResults = _resolveComponent("AnthropometryResults")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_AnthropometryResults, {
      loading: _ctx.getAnalysisLoading === 'loading',
      filters: _ctx.filters,
      tables: _ctx.getAnthroAnalysis.tables,
      plot: _ctx.getAnthroAnalysis.plot,
      prevalence: _ctx.getAnthroAnalysis.prevalences,
      "survey-info": _ctx.getAnthroAnalysis.surveyInfo,
      onFilterDelta: _ctx.onFilterChange,
      anthroAnalysisNotEnoughData: _ctx.getAnalysisLoading === 'cancelled'
    }, null, 8, ["loading", "filters", "tables", "plot", "prevalence", "survey-info", "onFilterDelta", "anthroAnalysisNotEnoughData"])
  ]))
}